import { DEVELOPMENT_ENV, PRODUCTION_ENV, STAGING_ENV } from './environment';
import {
  WORKSPACE_PLAN_BUSINESS,
  WORKSPACE_PLAN_ENTERPRISE,
  WORKSPACE_PLAN_STARTER_FREE,
} from './workspacePlans';

export const LOOM_STARTER_FREE_DISPLAY_NAME = 'Starter';
export const LOOM_BUSINESS_DISPLAY_NAME = 'Business';
export const LOOM_ENTERPRISE_DISPLAY_NAME = 'Enterprise';
export const LOOM_EDUCATION_DISPLAY_NAME = 'for Education';

export const LOOM_BUSINESS_MONTHLY_PLAN_KEY = 'loom_business_monthly';
export const LOOM_BUSINESS_QUARTERLY_PLAN_KEY = 'loom_business_quarterly';
export const LOOM_BUSINESS_YEARLY_PLAN_KEY = 'loom_business_yearly';
export const LOOM_BUSINESS_SALES_LED_MONTHLY_PLAN_KEY =
  'loom_business_sales_led_monthly';
export const LOOM_BUSINESS_SALES_LED_YEARLY_PLAN_KEY =
  'loom_business_sales_led_yearly';

export const LOOM_ENTERPRISE_BETA_MONTHLY_PLAN_KEY =
  'loom_enterprise_beta_monthly';
export const LOOM_ENTERPRISE_BETA_QUARTERLY_PLAN_KEY =
  'loom_enterprise_beta_quarterly';
export const LOOM_ENTERPRISE_BETA_YEARLY_PLAN_KEY =
  'loom_enterprise_beta_yearly';
// Billing warnings types
export const SELF_SERVE_BILLING_WARNING = 'self_serve_billing_warning';
export const SALES_LED_THRESHOLD_BILLING_WARNING =
  'sales_led_threshold_billing_warning';
export const SALES_LED_EXCEEDED_BILLING_WARNING =
  'sales_led_exceeded_billing_warning';

// billing detail
export const BILLING_DETAIL_DISCOUNT_TYPE_AMOUNT = 'amount';
export const BILLING_DETAIL_DISCOUNT_TYPE_PERCENT = 'percent';

// TODO: Deprecate below plans
export const LOOM_STARTER_FREE_PLAN_KEY = 'loom_starter_free';
export const LOOM_BUSINESS_PLAN_KEYS = new Set([
  LOOM_BUSINESS_MONTHLY_PLAN_KEY,
  LOOM_BUSINESS_QUARTERLY_PLAN_KEY,
  LOOM_BUSINESS_YEARLY_PLAN_KEY,
  LOOM_BUSINESS_SALES_LED_MONTHLY_PLAN_KEY,
  LOOM_BUSINESS_SALES_LED_YEARLY_PLAN_KEY,
]);

export const LOOM_ENTERPRISE_BETA_PLAN_KEYS = new Set([
  LOOM_ENTERPRISE_BETA_MONTHLY_PLAN_KEY,
  LOOM_ENTERPRISE_BETA_QUARTERLY_PLAN_KEY,
  LOOM_ENTERPRISE_BETA_YEARLY_PLAN_KEY,
]);

// higher number is higher priority
export const LOOM_PLAN_TO_PRIORITY_MAP = {
  [LOOM_STARTER_FREE_PLAN_KEY]: 0,
  [LOOM_BUSINESS_MONTHLY_PLAN_KEY]: 3,
  [LOOM_BUSINESS_QUARTERLY_PLAN_KEY]: 3,
  [LOOM_BUSINESS_YEARLY_PLAN_KEY]: 3,
  [LOOM_BUSINESS_SALES_LED_MONTHLY_PLAN_KEY]: 3,
  [LOOM_BUSINESS_SALES_LED_YEARLY_PLAN_KEY]: 3,
  [LOOM_ENTERPRISE_BETA_MONTHLY_PLAN_KEY]: 4,
  [LOOM_ENTERPRISE_BETA_QUARTERLY_PLAN_KEY]: 4,
  [LOOM_ENTERPRISE_BETA_YEARLY_PLAN_KEY]: 4,
};

export const LOOM_ACTIVE_TEAM_PLAN_KEYS = new Set([
  LOOM_STARTER_FREE_PLAN_KEY,

  LOOM_BUSINESS_MONTHLY_PLAN_KEY,
  LOOM_BUSINESS_QUARTERLY_PLAN_KEY,
  LOOM_BUSINESS_YEARLY_PLAN_KEY,

  LOOM_ENTERPRISE_BETA_MONTHLY_PLAN_KEY,
  LOOM_ENTERPRISE_BETA_QUARTERLY_PLAN_KEY,
  LOOM_ENTERPRISE_BETA_YEARLY_PLAN_KEY,
]);

export const LOOM_ACTIVE_YEARLY_PLAN_KEYS = new Set([
  LOOM_BUSINESS_YEARLY_PLAN_KEY,
  LOOM_BUSINESS_SALES_LED_YEARLY_PLAN_KEY,
  LOOM_ENTERPRISE_BETA_YEARLY_PLAN_KEY,
]);

export const LOOM_ACTIVE_MONTHLY_PLAN_KEYS = new Set([
  LOOM_BUSINESS_MONTHLY_PLAN_KEY,
  LOOM_BUSINESS_SALES_LED_MONTHLY_PLAN_KEY,
  LOOM_ENTERPRISE_BETA_MONTHLY_PLAN_KEY,
]);

export const DEFAULT_TRUE_UP_PERIOD = {
  pending_invoice_item_interval: {
    interval: 'month',
    interval_count: 1,
  },
};

export const INVITE_STATUS_CREATED = 'created';
export const INVITE_STATUS_SENT = 'sent';
export const INVITE_STATUS_FAILED = 'failed';
export const INVITE_STATUS_REMOVED = 'removed';
export const INVITE_STATUS_ACCEPTED = 'accepted';
export const INVITE_STATUS_INELIGIBLE = 'ineligible';

export const INVITE_TYPE_ADMIN = 'Admin';
export const INVITE_TYPE_MEMBER = 'Member';

export const ALL_INVITE_ROLE_TYPES = [INVITE_TYPE_ADMIN, INVITE_TYPE_MEMBER];

export const INVOICE_STATUS_DRAFT = 'draft';

export const SUBSCRIPTION_STATUS_TRIALING = 'trialing';
export const SUBSCRIPTION_STATUS_ACTIVE = 'active';
export const SUBSCRIPTION_STATUS_CANCELED = 'canceled';
export const SUBSCRIPTION_STATUS_PAST_DUE = 'past_due';
export const SUBSCRIPTION_STATUS_UNPAID = 'unpaid';
export const SUBSCRIPTION_STATUS_INCOMPLETE = 'incomplete';
export const SUBSCRIPTION_STATUS_INCOMPLETE_EXPIRED = 'incomplete_expired';

// this flag is unique since it is loom specific only and isn't
// available stripe side, this lets us know that someone has finished
// their trial
export const TRIAL_STATUS_FINISHED = 'finished';

export const INVITE_UPDATE_ERROR_UNAUTHORIZED = 'USER_IS_UNAUTHORIZED';
export const INVITE_VALIDATION_ERROR = 'USER_VALIDATION_ERR';

export const DASHBOARD_UPGRADE_BANNER_VIDEO_LIMIT = 16;

// experimental banner limit for lower paywall experiment
export const DASHBOARD_UPGRADE_BANNER_EXP_VIDEO_LIMIT = 11;

export const LOOM_BUSINESS_TRIAL_DAYS = 14;

// Threshold that is used when there are more than 10 people in the workspace.
// Don't use this constant directly, see shared/billingAndPayment.js#isSeatCountAtWarningThreshold
export const SALES_LED_SEAT_COUNT_THRESHOLD = 0.9;

// contact use reasons from plan and billing page, controls where the emails go
// and what copy they see
export const CONTACT_US_REASON_BILLING_ISSUE = 'Billing Issue';
export const CONTACT_US_REASON_ALTERNATIVE_PAYMENT =
  'Alternative Payment Method';
export const CONTACT_US_REASON_PAY_FOR_ENTERPRISE = 'Pay for Enterprise';

export const MARKETING_COPY_ENTERPRISE_ONLY_FEATURE_LIST = ['SSO (SAML)'];
export const MARKETING_COPY_BUSINESS_PLAN_ONLY_FEATURE_LIST = [
  'Custom branding',
  'Engagement insights',
  'Shared Library',
];

export const MAP_WORKSPACE_TYPE_TO_FEATURE_LISTS_MARKETING_COPY = {
  [WORKSPACE_PLAN_ENTERPRISE]: MARKETING_COPY_ENTERPRISE_ONLY_FEATURE_LIST,
  [WORKSPACE_PLAN_BUSINESS]: MARKETING_COPY_BUSINESS_PLAN_ONLY_FEATURE_LIST,
};

export const MARKETING_COPY_FINAL_ENTERPRISE_ONLY_FEATURE_LIST = ['SSO (SAML)'];
export const MARKETING_COPY_FINAL_BUSINESS_PLAN_ONLY_FEATURE_LIST = [
  'Drawing tool & mouse emphasis',
  'Custom recording dimensions',
  'Calls-to-action',
  'Custom branding',
  'Engagement insights',
];

export const MAP_WORKSPACE_TYPE_TO_FINAL_FEATURE_LISTS_MARKETING_COPY = {
  [WORKSPACE_PLAN_ENTERPRISE]:
    MARKETING_COPY_FINAL_ENTERPRISE_ONLY_FEATURE_LIST,
  [WORKSPACE_PLAN_BUSINESS]:
    MARKETING_COPY_FINAL_BUSINESS_PLAN_ONLY_FEATURE_LIST,
};

const MARKETING_COPY_FINAL_ENTERPRISE_LIMIT_LIST = [
  'Unlimited videos',
  'Unlimited recording length',
];

const MARKETING_COPY_FINAL_BUSINESS_LIMIT_LIST = [
  'Unlimited videos',
  'Unlimited recording length',
];

const MARKETING_COPY_FINAL_STARTER_FREE_LIMIT_LIST = [
  '25 videos per user',
  '5 min recording length',
];

export const MAP_WORKSPACE_TYPE_TO_FINAL_LIMIT_LIST_MARKETING_COPY = {
  [WORKSPACE_PLAN_ENTERPRISE]: MARKETING_COPY_FINAL_ENTERPRISE_LIMIT_LIST,
  [WORKSPACE_PLAN_BUSINESS]: MARKETING_COPY_FINAL_BUSINESS_LIMIT_LIST,
  [WORKSPACE_PLAN_STARTER_FREE]: MARKETING_COPY_FINAL_STARTER_FREE_LIMIT_LIST,
};

export const STRIPE_PRODUCT_ID_BUSINESS_MAP = {
  [DEVELOPMENT_ENV]: 'prod_GGLYC8T3hlURXA',
  [STAGING_ENV]: 'prod_GHuNn94RJ0YyoN',
  [PRODUCTION_ENV]: 'prod_GHvpjrKerSv5ZX',
};

export const STRIPE_PRODUCT_ID_BUSINESS_SALES_LED_MAP = {
  [DEVELOPMENT_ENV]: 'prod_Jyl1NmVZ011WmU',
  [STAGING_ENV]: 'prod_K0g0xE4d2LHhsu',
  [PRODUCTION_ENV]: 'prod_K0g0ZzOh7Wi7kR',
};

export const STRIPE_PRODUCT_ID_ENTERPRISE_MAP = {
  [DEVELOPMENT_ENV]: 'prod_GOIWpuIRFsFuOm',
  [STAGING_ENV]: 'prod_GOfWAsKomO8Fi3',
  [PRODUCTION_ENV]: 'prod_GOfUFHaKoU2F34',
};

// If an interval of a subscription is either 'month' or 'year
export const STRIPE_INTERVAL_MONTH = 'month';
export const STRIPE_INTERVAL_YEAR = 'year';

// checkout steps on upgrade / downgrade screens
export const CHECKOUT_STEP_UPGRADE_MEMBERS = 'upgrade_members';
export const CHECKOUT_STEP_CONFIRM_PAYMENT_DETAILS = 'confirm_payment_details';
export const CHECKOUT_STEP_SUCCESS = 'checkout_success';
